import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import singleChoice from '@/views/questionnaire/customerManage/questionnaireList/components/singleChoice.vue';
import tableControl from '@/views/questionnaire/customerManage/questionnaireList/components/tableControl.vue';
import multipleChoice from '@/views/questionnaire/customerManage/questionnaireList/components/multipleChoice.vue';
import dateControl from '@/views/questionnaire/customerManage/questionnaireList/components/dateControl.vue';
import dropDownSelect from '@/views/questionnaire/customerManage/questionnaireList/components/dropDownSelect.vue';
import signModel from '@/views/questionnaire/customerManage/questionnaireList/components/signModel.vue'; //签名组件
import paragraphModel from '@/views/questionnaire/customerManage/questionnaireList/components/paragraphModel.vue'; //段落
import enclosureModel from '@/views/questionnaire/customerManage/questionnaireList/components/enclosureModel.vue'; //附件
import formControlItem from '@/components/examine/formControlItem.vue';
import singleLineMultilineModel from '@/views/questionnaire/customerManage/questionnaireList/components/singleLineMultilineModel.vue'; //单行文本and多行文本
import topTitle from '@/components/title';
import { mapState } from 'vuex';
import formItemMixin from '@/mixins/formItemMixin';
import { checkEmail } from '@/utils/validate';
export default {
  props: {
    editableArea: {
      type: Array,
      default() {
        return [];
      }
    },
    echoNodeIsEdit: {
      type: Boolean,
      default: false //false不可以编辑true可编辑
    }
  },
  mixins: [formItemMixin],
  components: {
    singleChoice,
    tableControl,
    multipleChoice,
    dateControl,
    dropDownSelect,
    signModel,
    paragraphModel,
    enclosureModel,
    topTitle,
    singleLineMultilineModel,
    formControlItem
  },
  computed: {
    ...mapState({
      countriesData: state => state.quiretionnaire.countriesData,
      provinceFirstLevel: state => state.quiretionnaire.provinceFirstLevel,
      provinceData: state => state.quiretionnaire.provinceData,
      provinceArea: state => state.quiretionnaire.provinceArea,
      logisticsData: state => state.quiretionnaire.logisticsData,
      bankData: state => state.quiretionnaire.bankData
    })
  },
  created() {
    this.editableArea && Array.isArray(this.editableArea) && this.editableArea.forEach(item2 => {
      item2.form.forEach(control => {
        console.log(control.control.mark, '----');
        if (control.controlType === 'control') {
          var _control$control;
          control.control.mark = (_control$control = control.control) === null || _control$control === void 0 ? void 0 : _control$control.mark.replace('d.', 'd_');
          this.setEchoForm(control.control);
        } else {
          control.mark = control.mark.replace('d.', 'd_');
          let groupControl = control.control;
          groupControl.forEach(item => {
            item.mark = item.mark.replace('d.', 'd_');
            this.setEchoForm(item);
          });
        }
        //设置控件显隐 以及处理关联关系
        this.setAssociationInfo(control);
      });
    });
    this.formatRules();
  },
  data() {
    return {
      formData: {},
      showControl: {},
      rules: {},
      associationInfo: {},
      vidateStatus: true,
      submitData: []
    };
  },
  methods: {
    valueChangeValidate(key) {
      this.$refs.form.validateField(key);
    },
    // validateEmail(rules, value, callback) {
    //   if (value && !checkEmail(value)) {
    //     callback(new Error(this.$t('邮箱格式有误，请重新填写')));
    //   }
    //   callback();
    // },
    formatDropResourceMap() {
      const loop = (data, obj) => {
        data.forEach(item => {
          obj[item.id] = item.name;
          if (item.children) {
            loop(item.children, obj);
          }
        });
        return obj;
      };
      this.countriesDataMap = loop(this.countriesData, {});
      this.provinceFirstLevelObj = loop(this.provinceFirstLevel, {});
      this.provinceDataObj = loop(this.provinceData, {});
      this.provinceAreaObj = loop(this.provinceArea, {});
      this.logisticsDataObj = loop(this.logisticsData, {});
      this.bankDataObj = loop(this.bankData, {});
    },
    formatRules() {
      this.editableArea && Array.isArray(this.editableArea) && this.editableArea.forEach(item2 => {
        item2.form.forEach(item3 => {
          if (item3.controlType === 'control') {
            let rules = this.generateValidateRule(item3.control);
            if (rules.length > 0) {
              this.$set(this.rules, item3.control.mark, rules);
            }
          } else if (item3.controlType === 'controlGroup') {
            item3.control.forEach(item4 => {
              let rules = this.generateValidateRule(item4);
              if (rules.length > 0) {
                this.$set(this.rules, item4.mark, rules);
              }
            });
          }
        });
      });
      console.log(this.rules, 'this.rules');
    },
    changeControlShow(value, key) {
      this.$set(this.showControl, key, value);
    },
    // handleControlValue(controlItem) {
    //   //处理控件的value值
    //   if (controlItem.partsType === 'dropDown') {
    //     let value = this.formData[controlItem.mark];
    //     controlItem.value = this.handleDropDownData(value, controlItem);
    //   } else if (controlItem.partsType === 'date') {
    //     //日期组件处理格式
    //     let value = this.formData[controlItem.mark];
    //     controlItem.value = value ? moment(value).format(controlItem.dateType) : '';
    //   } else if (controlItem.partsType !== 'table') {
    //     controlItem.value = this.formData[controlItem.mark] || '';
    //   }
    //   controlItem.mark = controlItem.mark.replace('d_', 'd.');
    // },
    onSubmit() {
      let tableValidateStatus = this.validateTable();
      if (!tableValidateStatus) {
        this.vidateStatus = false;
        return;
      }
      this.formatDropResourceMap();
      this.$refs.form.validate(valid => {
        this.vidateStatus = valid;
        this.generateTableData();
        this.submitData = JSON.parse(JSON.stringify(this.editableArea));
        if (valid) {
          this.submitData && Array.isArray(this.submitData) && this.submitData.forEach(nodeItem => {
            nodeItem.form.forEach(controlItem => {
              if (controlItem.controlType === 'controlGroup') {
                controlItem.control.forEach(item => {
                  this.handleControlValue(item);
                });
              } else {
                this.handleControlValue(controlItem.control);
              }
            });
          });
          console.log(this.submitData, '---submitData---');
        }
      });
    },
    validateTable() {
      //验证表格数据
      this.editableArea && Array.isArray(this.editableArea) && this.editableArea.forEach(nodeItem => {
        nodeItem.form.forEach(controlItem => {
          if (controlItem.controlType === 'controlGroup') {
            //控件组
            controlItem.control.forEach(item => {
              if (item.partsType === 'table' && this.showControl[item.mark]) {
                this.$refs[`control${item.mark}`][0].validateTable();
              }
            });
          } else if (controlItem.control.partsType === 'table' && this.showControl[controlItem.control.mark]) {
            this.$refs[`control${controlItem.control.mark}`][0].validateTable();
          }
        });
      });
      let validateStatus = true;
      let length = this.editableArea && Array.isArray(this.editableArea) ? this.editableArea.length : 0;
      for (let m = 0; m < length; m++) {
        let nodeItem = this.editableArea[m];
        for (let j = 0; j < nodeItem.form.length; j++) {
          let controlItem = nodeItem.form[j];
          if (controlItem.controlType === 'controlGroup') {
            //控件组
            for (let k = 0; k < controlItem.control.length; k++) {
              let item = controlItem.control[k];
              if (item.partsType === 'table' && this.showControl[item.mark]) {
                if (!this.$refs[`control${item.mark}`][0].$refs[`table${item.mark}`].validateStatus) {
                  validateStatus = false;
                }
                if (!validateStatus) {
                  break;
                }
              }
            }
          } else if (controlItem.control.partsType === 'table' && this.showControl[controlItem.control.mark]) {
            if (!this.$refs[`control${controlItem.control.mark}`][0].$refs[`table${controlItem.control.mark}`].validateStatus) {
              validateStatus = false;
            }
          }
          if (!validateStatus) {
            break;
          }
        }
        if (!validateStatus) {
          break;
        }
      }
      return validateStatus;
    },
    generateTableData() {
      this.editableArea && Array.isArray(this.editableArea) && this.editableArea.forEach(nodeItem => {
        nodeItem.form.forEach(controlItem => {
          var _controlItem$control;
          if (controlItem.controlType === 'controlGroup') {
            controlItem.control.forEach(item => {
              if (item.partsType === 'table' && this.showControl[controlItem.mark]) {
                this.$refs[`control${item.mark}`][0].generationData();
              }
            });
          } else if (((_controlItem$control = controlItem.control) === null || _controlItem$control === void 0 ? void 0 : _controlItem$control.partsType) === 'table' && this.showControl[controlItem.control.mark]) {
            this.$refs[`control${controlItem.control.mark}`][0].generationData();
          }
        });
      });
    },
    handleDropDownData(value, item) {
      //下拉选择的value格式处理
      if (!value) {
        return {
          textValue: [],
          codeValue: []
        };
      }
      const generaterText = mapObj => {
        let textValue = [];
        value.forEach(valueArr => {
          let text = '';
          if (Array.isArray(valueArr) && valueArr.length > 0) {
            //多选
            valueArr.forEach((value, index) => {
              if (index === valueArr.length - 1) {
                text = text + mapObj[value];
              } else {
                text = text + mapObj[value] + '/';
              }
            });
          } else {
            //单选
            text = mapObj[valueArr];
          }
          textValue.push(text);
        });
        return textValue;
      };
      let textData = [];
      let dataType = item.type.type;
      if (dataType === 'provinceArea') {
        textData = generaterText(this.provinceAreaObj);
      } else if (dataType === 'province') {
        textData = generaterText(this.provinceDataObj);
      } else if (dataType === 'provinceFirstLevel') {
        textData = generaterText(this.provinceFirstLevelObj);
      } else if (dataType === 'country') {
        textData = generaterText(this.countriesDataMap);
      } else if (dataType === 'bank') {
        textData = generaterText(this.bankDataObj);
      } else if (dataType === 'logistics') {
        textData = generaterText(this.logisticsDataObj);
      } else if (dataType === 'custom') {
        const loop = (data, obj) => {
          data.forEach(item => {
            obj[item.id] = item.name;
            if (item.children) {
              loop(item.children, obj);
            }
          });
          return obj;
        };
        let mapObj = loop(item.dataList, {});
        textData = generaterText(mapObj);
      }
      return {
        textValue: textData,
        codeValue: value
      };
    }
  }
};